/**
 * Wrap a dispatch creation call so that a 409 EQUIPMENT_OUT_OF_SERVICE
 * response prompts the dispatcher to confirm an override, then retries.
 *
 * Usage:
 *   await createDispatchWithOverride((override) =>
 *     api.post('/dispatches', { ...payload, override_out_of_service: override })
 *   );
 */
export async function createDispatchWithOverride(doRequest) {
  try {
    return await doRequest(false);
  } catch (error) {
    const detail = error?.response?.data?.detail;
    const code = typeof detail === 'object' ? detail?.code : null;
    if (error?.response?.status === 409 && code === 'EQUIPMENT_OUT_OF_SERVICE') {
      const issues = detail?.open_issues || [];
      const summary = issues
        .slice(0, 3)
        .map(
          (i) =>
            `• [${(i.severity || '').toUpperCase()}] ${i.title || 'Issue'}${
              i.equipment_label ? ` — ${i.equipment_label}` : ''
            }`,
        )
        .join('\n');
      const more = issues.length > 3 ? `\n…and ${issues.length - 3} more` : '';
      const confirmed = window.confirm(
        `⚠️ This driver has ${issues.length} open critical equipment issue(s):\n\n` +
          `${summary}${more}\n\n` +
          `Assigning this dispatch anyway will be logged as a dispatcher override.\n\n` +
          `Continue and override?`,
      );
      if (!confirmed) {
        const cancelErr = new Error('Dispatch cancelled — equipment out of service');
        cancelErr.handled = true;
        throw cancelErr;
      }
      return await doRequest(true);
    }
    throw error;
  }
}
